import React from 'react';
import RequireEvent from '../../components/RequireEvent';
import { choose } from '../../utils/platform';
import { useExpenses } from './useExpenses';
import ExpensesDesktop from './Expenses.desktop';
import ExpensesMobile from './Expenses.mobile';

const ExpensesView = choose(ExpensesDesktop, ExpensesMobile);

function ExpensesInner({ event }) {
  const vm = useExpenses(event);
  return <ExpensesView vm={vm} />;
}

// /app/expenses — what the event costs, what is paid, what is still due.
export default function Expenses() {
  return <RequireEvent>{(event) => <ExpensesInner event={event} />}</RequireEvent>;
}
